
export default {
  props: {
    endpoint: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      baseUrl: null,
      networks: [
        {
          icon: "ui-icons-facebook",
          name: "Facebook",
        },
        {
          icon: "ui-icons-viber",
          name: "Viber",
        },
        {
          icon: "ui-icons-whatsApp",
          name: "WhatsApp",
        },
        {
          icon: "ui-icons-telegram",
          name: "Telegram",
        },
      ],
    };
  },
  mounted() {
    this.baseUrl = window.location.origin;
  },
};
